module.exports = __webpack_public_path__ + "img/img (7).6f6db383.jpg";